<template>
	<div class="header-bar-component flex component padding shandow border">
		<div class="head-title">
			<i class="el-icon-tickets"></i>
			<span>{{ name||"项目" }}</span>
			<span :key="item" v-for="item in steps"> / {{ item }}</span>
		</div>
		<div class="head-handle">
			<slot></slot>
		</div>
	</div>
</template>

<script>
export default {
	name: 'header-bar',
	props: {
		name: "",
		steps: Array
	}
}
</script>

<style lang="scss" scoped>
@import '../../styles/commom';

.header-bar-component {
	box-sizing: border-box;
	justify-content: space-between;
	height: 60px;
	background: #fff;
	font-size: 16px;
	color: #333;
	cursor: pointer;

	span {
		color: $blue;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/bar/head-bar.vue